<template>
<div class="hy-split-wrapper">
  <map-view ref="map-view" :model="model" :trjtype="trjtype" :data-list="dataList" @site-click="onSiteClick" />

  <div class="params-panel">
    <el-form
      ref="form"
      :model="model"
      size="small"
    >
      <hy-split-type-selector :model="model" />

      <date-selector :model="model" @change="onDateChange" />

      <duration-selector :model="model" />

      <height-checkbox-group v-if="model.trjtype === 1" :model="model" />
      <height-radio-group v-else-if="model.trjtype === 3" :model="model" />

      <site-selector ref="site-selector" :model="model" />

      <el-form-item>
        <el-switch v-model="model.showChart" active-text="显示图表" />
      </el-form-item>
    </el-form>

    <div class="params-panel-footer">
      <el-button type="success" size="small" icon="el-icon-download" @click="onExportBtnClick">导出</el-button>
      <el-button type="primary" size="small" icon="el-icon-search" @click="onSearchBtnClick">查询</el-button>
    </div>
  </div>
</div>
</template>

<script>
import html2canvas from 'html2canvas'
import Option from './Option'

import BaseStore from '../../../../components/BaseStore'

import MapView from './MapView'
import HySplitTypeSelector from './HySplitTypeSelector'
import SiteSelector from './SiteSelector'
import DateSelector from './DateSelector'
import DurationSelector from './DurationSelector'
import HeightCheckboxGroup from './HeightCheckboxGroup'
import KmzParser from './KmzParser'
import HeightRadioGroup from './HeightRadioGroup'

export default {
  name: 'DataDisplayHYSPLIT',
  routeInfo: {
    label: 'HYSPLIT',
    icon: 'fa fa-users'
  },
  extends: BaseStore,
  components: {HeightRadioGroup, HeightCheckboxGroup, DurationSelector, DateSelector, SiteSelector, HySplitTypeSelector, MapView},
  data: () => {
    return {
      model: {
        taskId: null,
        trjtype: null,
        lon: 0,
        lat: 0,
        mfile: null,
        hour: null,
        duration: null,
        hgt1: null,
        hgt2: null,
        hgt3: null,
        url: null,
        siteId: null,
        hideNotSelectedSite: false,
        showChart: true
      },
      date: null,
      dataList: Object.freeze([]),
      exportName: 'HYSPLIT',
      trjtype: null
    }
  },
  computed: {
    hySplitTypeMap () {
      return Option.hySplitTypes.reduce((map, hySplitType) => {
        map[hySplitType.value] = hySplitType.label
        return map
      }, {})
    }
  },
  methods: {
    onSiteClick (site) {
      this.$refs['site-selector'].onSiteClick(site, true)
    },
    onDateChange (date) {
      this.date = Object.freeze(new Date(date))
    },
    onExportBtnClick () {
      let screenShotWrapper = this.$refs['map-view'].$el
      html2canvas(screenShotWrapper, {
        logging: true,
        allowTaint: true,
        useCORS: true,
        scale: 1
      }).then(canvas => {
        canvas.toBlob(blob => {
          let url = URL.createObjectURL(blob)
          let link = document.createElement('a')
          link.download = `${this.exportName}.png`
          link.href = url
          link.click()
          URL.revokeObjectURL(url)
        })
      })
    },
    onSearchBtnClick () {
      this.$refs.form.validate(flag => {
        if (flag) {
          this.getStep3()
        }
      })
    },
    getStep3 () {
      this.changeLoadStatus(true)
      let {model, date} = this
      let query = {
        year: date.format('YY'),
        month: date.format('MM'),
        day: date.format('DD'),
        hour: model.hour,
        hgt1: model.hgt1,
        lon: model.lon,
        lat: model.lat,
        duration: model.duration
      }

      let {hgt2, hgt3} = model

      if (Number.isFinite(hgt2)) {
        query.hgt2 = hgt2
      }

      if (Number.isFinite(hgt3)) {
        query.hgt3 = hgt3
      }

      this.$api.HYSPLIT.step3(model.taskId, query).then(data => {
        this.model.url = data.url
        setTimeout(() => {
          this.getStep4()
        }, 5000)
      }).catch(error => {
        console.error(error)
        this.changeLoadStatus(false)
      })
    },
    getStep4 () {
      clearTimeout(this.timer)
      // this.changeLoadStatus(true)
      let {model} = this

      this.$api.HYSPLIT.step4(model.taskId, model).then(data => {
        if (Object.values(data).length === 0) {
          this.timer = setTimeout(() => {
            this.getStep4()
          }, 5000)
        } else {
          this.changeLoadStatus(false)

          let {kmz} = data

          if (kmz) {
            setTimeout(() => {
              this.downloadKmzFile(kmz)
            }, 0)
          } else {
            let {error} = data

            if (error) {
              this.$notify({
                title: '错误',
                message: error,
                type: 'error',
                position: 'bottom-right'
              })
            }
          }
        }
      }).catch(error => {
        console.error(error)
        this.changeLoadStatus(false)
      })
    },
    downloadKmzFile (kmzUrl) {
      this.changeLoadStatus(true)
      KmzParser.getKmzData(kmzUrl).then(data => {
        this.dataList = Object.freeze(data)
        let {model} = this
        this.exportName = `${this.profileSiteMap[model.siteId].name}_${this.hySplitTypeMap[model.trjtype]}_${this.date.format(`YYYY-MM-DD ${model.hour}`)}_${model.duration}小时_${model.hgt1}米${model.trjtype === 1 ? `${Number.isFinite(model.hgt2) ? `_${model.hgt2}米${Number.isFinite(model.hgt3) ? `_${model.hgt3}米` : ''}` : ''}` : ''}`
        this.trjtype = model.trjtype
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    }
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  }
}
</script>

<style lang="scss" scoped>
.hy-split-wrapper {
  display: grid;
  grid-template-columns: auto max-content;
  width: 100%;
  height: 100%;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }

  > .params-panel {
    display: grid;
    grid-template-rows: auto max-content;
    background-color: #ffffff;
    overflow: auto;

    > * {
      min: {
        width: 0;
        height: 0;
      }
    }

    > .el-form {
      padding: 12px 24px;
      overflow: auto;
    }

    > .params-panel-footer {
      display: flex;
      justify-content: flex-end;
      padding: 12px 24px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/03Pollution/04HYSPLIT/index.vue